module.exports = __webpack_public_path__ + "img/dcmm_28.613e6aed.png";